import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import config from 'client/shared/config';

import AuditionHeader from './audition-header';
import AuditionSongList from './audition-song-list';

@inject('artistStore', 'userStore', 'songsStore')
@observer
class ViewAudition extends React.Component {
	render () {
		const { artistStore, userStore, songsStore } = this.props;

		if (songsStore.isLoading || artistStore.isLoading) {

			return null;
		}

		return (
			<div className="grid-x">
				<AuditionHeader />
				
				<div className="cell auto divider-vertical">
					<div className="grid-y" style={{
						height: 'calc(100vh - 10rem)'
					}}>
						<div className="cell auto margin-bottom-1" style={{
							overflow: 'auto'
						}}>
							<AuditionSongList />
						</div>

						<div className="cell shrink">
							<button
								data-ta="auditionSubmitBtn"
								onClick={ this.onSubmitClick }
								className="button clear large margin-0"
							>
								<span className="fas fa-cloud-upload"></span> Submit
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	async onSubmitClick () {
		const { artistStore } = this.props;
		const { ACTIVE, INACTIVE } = artistStore.status;
		const artist = artistStore.data.artist.toPOJO();
		const numSongs = artist.songs.length || 0;
		if (numSongs < 5) {
			alert("Unable to confirm submission. Artists must upload 5+ songs to qualify.");
			return false;
		}

		artist.tier = artistStore.tier;
		artist.status = (/tier/i).test(artist.tier) ? ACTIVE : INACTIVE;

		await artistStore.saveArtist({
			...artist,
			type: artistStore.changeTypes.UPDATE
		});

		window.location.href = config.paths.admin.submissionsHomePath;
	}
}

// Wrap the component to inject dispatch and state into it
export default ViewAudition;
